<template>
  <div class="saved-location">
    <div class="title">
      <span>
        saved locations
      </span>
    </div>
    <SingleLocation 
      v-for="(l, index) in locations"
      :key="`location-${index}`"
      :location="l"
      @set-edit="$emit('edit-location', l)"
      @set-delete="$emit('remove-location', l)" />
  </div>
</template>
<script>
import SingleLocation from './SingleLocation.vue'
export default {
  components: {
    SingleLocation
  },
  props: {
    locations: {
      type: Array,
      default: () => []
    }
  }
}
</script>